import React from 'react';
import * as _ from 'lodash';

import styles from '../../styles/componentStyle/selectBox/selectBox.scss';
import { ArrowDownIcon } from '../icons/ArrowDownIcon';

/**
 * プレースホルダー付きのセレクトボックス ( メインは検索等で使用する )
 * @props {string}label:ラベル
 * @props {string}name:セレクトタグのname属性
 * @props {string}value:変化させたいステートのパラメーター
 * @props {string}placeholder:セレクトタグ内の初期表示する内容
 * @props {boolean}disabled:selectBoxを操作可能状態にするか？
 * @props {boolean}isPlaceholderDisabled:placeholderを選択可能にするか？
 * @props {boolean}isPlaceholderHidden:placeholderを隠すか？
 * @props {array}items:セレクトタグで表示する配列
 * @props {string}valueName:optionタグのvalueに設定したい配列内のKey名
 * @props {string}keyName:optionタグのkeyに設定したい配列内のKey名
 * @props {string}itemName:画面に表示したい配列内のKey名
 * @props {function}onChange:セレクトボックスのデータを選択した時の処理
 */
export class SelectBox extends React.Component {
  constructor(props) {
    super(props);
    if (
      this.props.onChange !== undefined &&
      typeof this.props.onChange === 'function'
    ) {
      this.onChange = this.props.onChange.bind(this);
    } else {
      console.warn('onChange is not function');
    }
  }

  setValue = val => {
    if (val === null || val === undefined) {
      return '';
    } else {
      return val;
    }
  };

  renderPlaceholder() {
    if (this.props.isPlaceholderHidden === true) {
      return;
    }

    return (
      <option value='' disabled={this.props.isPlaceholderDisabled}>
        {this.props.placeholder}
      </option>
    );
  }

  renderOptions() {
    return _.map(this.props.items, (item, index) => {
      if (typeof item !== 'object') {
        return (
          <option value={item} key={index}>
            {item}
          </option>
        );
      }

      return (
        <option
          value={item[this.props.valueName]}
          key={item[this.props.keyName]}
        >
          {item[this.props.itemName]}
        </option>
      );
    });
  }

  // 画面表示
  render() {
    return this.props.isFormListDefaultItem ? (
      <React.Fragment>
        <select
          name={this.props.name}
          value={this.setValue(this.props.value)}
          onChange={this.onChange}
          disabled={this.props.disabled}
        >
          {this.renderPlaceholder()}
          {this.renderOptions()}
        </select>
        <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
      </React.Fragment>
    ) : (
      <div className={styles.selectBox}>
        <div className='select-box'>
          <div className='select-box__label'>
            <span className='label'>{this.props.label}</span>
          </div>
          <div className='select-box__element'>
            <select
              name={this.props.name}
              value={this.setValue(this.props.value)}
              onChange={this.onChange}
              disabled={this.props.disabled}
            >
              {this.renderPlaceholder()}
              {this.renderOptions()}
            </select>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/select/SelectBox.jsx